import React from 'react';
import { MailIcon, ExternalLinkIcon } from 'lucide-react';
export function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <footer className="bg-navy py-16 border-t border-white/10" data-id="element-211">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-212">
        <div className="grid md:grid-cols-3 gap-12 mb-12" data-id="element-213">
          {/* Brand */}
          <div data-id="element-214">
            <h3 className="text-2xl font-serif font-bold text-white mb-4" data-id="element-215">
              CaboDealFlow.com
            </h3>
            <p className="text-white/60 leading-relaxed" data-id="element-216">
              Curated, data-driven real estate investment opportunities in Cabo
              San Lucas. Institutional-grade deal flow for sophisticated
              investors.
            </p>
          </div>

          {/* Quick Links */}
          <div data-id="element-217">
            <h4 className="text-white font-semibold mb-4" data-id="element-218">Quick Links</h4>
            <ul className="space-y-2" data-id="element-219">
              <li data-id="element-220">
                <button onClick={() => scrollToSection('deals')} className="text-white/60 hover:text-gold transition-colors" data-id="element-221">
                  Current Deal Flow
                </button>
              </li>
              <li data-id="element-222">
                <button onClick={() => scrollToSection('completed')} className="text-white/60 hover:text-gold transition-colors" data-id="element-223">
                  Completed Deals
                </button>
              </li>
              <li data-id="element-224">
                <button onClick={() => scrollToSection('deal-report')} className="text-white/60 hover:text-gold transition-colors" data-id="element-225">
                  Get Deal Report
                </button>
              </li>
              <li data-id="element-226">
                <button onClick={() => scrollToSection('about')} className="text-white/60 hover:text-gold transition-colors" data-id="element-227">
                  About
                </button>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div data-id="element-228">
            <h4 className="text-white font-semibold mb-4" data-id="element-229">Contact</h4>
            <div className="space-y-4" data-id="element-230">
              <a href="mailto:deals@cabodealflow.com" className="flex items-center text-white/60 hover:text-gold transition-colors" data-id="element-231">
                <MailIcon className="mr-2" size={18} data-id="element-232" />
                deals@cabodealflow.com
              </a>
              <a href="https://cabocollection.com" target="_blank" rel="noopener noreferrer" className="flex items-center text-white/60 hover:text-gold transition-colors" data-id="element-233">
                <ExternalLinkIcon className="mr-2" size={18} data-id="element-234" />
                CaboCollection.com
                <span className="ml-2 text-xs bg-gold/20 text-gold px-2 py-0.5 rounded" data-id="element-235">
                  Sister Site
                </span>
              </a>
            </div>
          </div>
        </div>

        {/* Legal Disclaimer */}
        <div className="border-t border-white/10 pt-8" data-id="element-236">
          <p className="text-white/40 text-sm leading-relaxed mb-6" data-id="element-237">
            <strong className="text-white/60" data-id="element-238">Legal Disclaimer:</strong> This is
            not financial advice. All investment decisions should be made with
            your own due diligence. Past performance does not guarantee future
            results. Real estate investments carry risk, including loss of
            principal. Cabo Deal Flow is an informational resource and does not
            provide investment advice, legal counsel, or tax guidance. Consult
            with qualified professionals before making any investment decisions.
          </p>
          <p className="text-white/40 text-sm text-center" data-id="element-239">
            © {new Date().getFullYear()} Cabo Deal Flow. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}